module.exports = __webpack_public_path__ + "static/media/ico_ymk.8667a1a2.svg";